module.exports = __webpack_public_path__ + "static/media/portfolio.714355ea.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio.JPG
// module id = 75
// module chunks = 0